import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ButtonGroup, Button } from "react-bootstrap";
import TagFeedItem from "./TagFeedItem";
import Loader from "../../../Shared/Loader";
import { httpDelete, httpGet } from "../../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import {
  NoFeedIcon,
  GoBackIcon,
  FacebookIcon,
  SocialBlogIcon,
  BlogIcon,
  PlusIcon,
  SocialForumIcon,
} from "../../../Icons/icons.component";
import { TAGS } from "../../../../constants/route-constants";
import { SOCIAL_PERPAGE_LIMIT, VERTICALS } from "../../../../constants/app-constant";

const TagFeeds = ({ history }) => {
  const { tagId, verticalId } = useParams();
  const { V_SOCIAL, V_BLOG, V_FORUM } = VERTICALS;

  const [feedsData, setFeedsData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [tagName, setTagName] = useState("");
  const [paginationData, setPaginationData] = useState({});
  const [feedsLoader, setFeedsLoader] = useState(false);

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  useEffect(() => {
    getTagName();
    if (!tagId) {
      history.push("/tags");
    }
  }, []);

  useEffect(() => {
    setLoader(true);
    if (selectedClient && selectedClient.id) {
      getTagsListByTagName();
    }
  }, [selectedClient, selectedClient.id]);

  const getTagName = () => {
    const paramName = history.location.search.split("=")[1];
    setTagName(paramName);
  };

  const getTagsListByTagName = (page = 1, feedsLoader = false) => {
    if (feedsLoader) {
      setFeedsLoader(true);
    } else {
      setLoader(true);
    }
    httpGet(
      `${unifiedEnvConfig.GET_FEEDS_BY_VERTICAL.replace(
        "{id}",
        tagId
      )}?client_id=${selectedClient.id}&searchParams[type]=${verticalId
      }&page=${page}&perPage=${SOCIAL_PERPAGE_LIMIT}`
    )
      .then((response) => {
        if (feedsLoader) {
          setFeedsLoader(false);
        } else {
          setLoader(false);
        }
        const { data, pagination } = response.data;
        setPaginationData(pagination);
        if (page != 1) {
          setFeedsData(data && data.length ? [...feedsData, ...data] : []);
        } else {
          setFeedsData(data && data.length ? data : []);
        }
      })
      .catch((error) => {
        if (feedsLoader) {
          setFeedsLoader(false);
        } else {
          setLoader(false);
        }
        console.log(error);
      });
  };

  const removeTag = (tabObject) => {
    httpDelete(
      `${unifiedEnvConfig.DELETE_TAG_FROM_FEED}?client_id=${selectedClient.id}`,
      tabObject
    ).catch((err) => {
      console.log(err);
      alert("Couldn't delete the tag. Please try again.");
    });
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="mainContainer tagsContainer">
          <div className="dashboardHeader dashboardDetailsHeader">
            <div className="dashboardHeaderTop d-flex">
              <div className="dhLeft d-flex">
                <div className="dhLeftWrap d-flex align-items-center">
                  <span
                    className="btnGoBack clickable"
                    onClick={() => history.push(TAGS)}
                  >
                    <GoBackIcon />
                  </span>
                  <h1>{decodeURI(tagName)}</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="tagsMiddleSection tagsDetailsSection">
            <div className="tdsTop">
              <ButtonGroup className="smallToggleBtnGroup">
                {verticalId == V_SOCIAL && (
                  <>
                    <Button className="tagBlue active">
                      <SocialBlogIcon />
                      Social
                    </Button>
                  </>
                )}
                {verticalId == V_BLOG && (
                  <>
                    <Button className="tagViolet active">
                      <BlogIcon />
                      Blogs
                    </Button>
                  </>
                )}
                {verticalId == V_FORUM && (
                  <>
                    <Button className="tagBrown active">
                      <SocialForumIcon />
                      Forum
                    </Button>
                  </>
                )}
              </ButtonGroup>
            </div>
            <div className="tagListingWrap">
              <div className="inner-feed-container">
                {feedsData && feedsData.length ? (
                  <>
                    {feedsData &&
                      feedsData.map((item) => {
                        return (
                          <TagFeedItem
                            removeTag={removeTag}
                            {...item}
                            verticalId={verticalId}
                            clientId={selectedClient.id}
                          />
                        );
                      })}
                    {
                      feedsData.length < paginationData.total
                        ? <div className="viewMoreBtnWrap">
                          {feedsLoader ? (
                            <Loader />
                          ) : (
                            <Button
                              className="btn btnBlue viewMoreBtn"
                              onClick={() => {
                                getTagsListByTagName(paginationData.page + 1, true);
                              }}
                            >
                              View More
                            </Button>
                          )}
                        </div>
                        : null
                    }
                  </>
                ) : (
                  <div className="noFilterDataWrap">
                    <NoFeedIcon />
                    <h6>No Feeds Found</h6>
                    <p>Please add tags to feeds</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TagFeeds;
